import { mapGetters, mapActions } from 'vuex';
import cookies from 'js-cookie';

import GET_PARTNERSHIP_QUERY from '~/graphql/queries/GetPartnership';
import { partnerships } from '~/vanityUrls.json';

export default {
  async fetch() {
    const partner = cookies.get('partner');
    const countryCode = this.$i18n.locale.toUpperCase();
    const vanityUrl = partnerships.find((p) => p.slug === this.$route.name);
    const vanitySlug = vanityUrl && vanityUrl.slug;

    if (vanitySlug || (!this.partnership && partner)) {
      await this.$apollo
        .query({
          query: GET_PARTNERSHIP_QUERY,
          variables: {
            id: vanitySlug || partner,
            country: countryCode,
          },
        })
        .then(({ data }) => {
          if (data.entry) {
            cookies.set('partner', partner || vanitySlug);
            this.setAppQuery(data.entry.appQueryParams);
            this.setPartnership(data.entry);
            this.setTheme(data.entry.themeColours);

            const overideBySaleBanner =
              this.saleBanner?.bannerEnabled &&
              this.saleBanner?.overrideCharityBanner;
            if (!overideBySaleBanner) {
              this.setBannerName(data.entry.name);
              this.setBannerLogo(data.entry.bannerLogo);
              this.setBannerText(data.entry.bannerText);
            }
          }
        })
        .catch((e) => {
          console.error(e.message);
          this.$router.push({
            path: this.localePath('/'),
            query: this.$route.query,
          });
        });
    }
  },
  fetchOnServer: false,
  computed: {
    ...mapGetters(['partnership']),
  },
  methods: {
    ...mapActions(['setTheme', 'setAppQuery', 'setPartnership']),
    ...mapActions('banner', [
      'setBannerName',
      'setBannerLogo',
      'setBannerText',
    ]),
  },
};
